$(document).ready(function () {
  $('.live-match-box').each(function () {
    const $section = $(this);
    const $slider = $section.find('.match-slider');
    const $thumbs = $section.find('.match-thumb-slider');
    const $current = $section.find('.current-slide');
    const $total = $section.find('.total-slides');
    const box = this;

    if (!$slider.length || !$thumbs.length) {
      return;
    }

    // Local date rewrite
    $slider.find('.match-slide[data-match-date]').each(function () {
      const d = new Date(this.dataset.matchDate);
      const items = $(this).find('.match-date ul li');
      items.eq(0).text(d.toLocaleDateString([], { day: 'numeric', month: 'long', year: 'numeric' }));
      items.eq(1).text(d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' }));
    });

    // Dwell time
    let dwellStart = null;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          dwellStart = Date.now();
        } else if (dwellStart) {
          dataLayer.push({ event: 'hero_dwell', dwell_seconds: Math.round((Date.now() - dwellStart) / 1000) });
          dwellStart = null;
        }
      });
    }, { threshold: 0.3 }).observe(box);

    window.addEventListener('pagehide', function () {
      if (dwellStart) dataLayer.push({ event: 'hero_dwell', dwell_seconds: Math.round((Date.now() - dwellStart) / 1000) });
    });

    // Match nav + Shop click tracking
    $(box).on('click', '[data-track]', function () {
      dataLayer.push(JSON.parse(this.dataset.track));
    });

    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      const current = (currentSlide || 0) + 1;
      $current.text(current);
      $total.text(slick.slideCount);

      $section.find('.match-thumb').removeClass('is-active').attr('aria-current', 'false');

      const activeIndex = slick.currentSlide || 0;

      $section
        .find('.match-thumb-item')
        .eq(activeIndex)
        .find('.match-thumb')
        .addClass('is-active')
        .attr('aria-current', 'true');
    });

    $thumbs.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: $slider,
      focusOnSelect: true,
      arrows: false,
      dots: false,
      infinite: false,
      variableWidth: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: $thumbs,
      arrows: true,
      prevArrow: $section.find('.match-prev'),
      nextArrow: $section.find('.match-next'),
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      speed: 200,
      cssEase: 'ease-out'
    });
  });
});